import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { FoodControlList } from './../models/food-control-list';
import { ManualControlServices } from './manual-control-services';

@Injectable()
export class ManualControlListResolver {
  constructor(private backend: ManualControlServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<FoodControlList[]> {
    return this.backend.getManualControlByParent(+route.params['Id']);
  }
}
@Injectable()
export class ManualControlEditResolver {
  constructor(private backend: ManualControlServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<FoodControlList[]> {
    return this.backend.getManualControlById(+route.params['mId']);
  }
}

@Injectable()
export class ManualTempControlResolver {
  constructor(private backend: ManualControlServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<FoodControlList[]> {
    return this.backend.ManageTemperatureControl(+route.params['Id']);
  }
}
